/*
 * @Author: luting
 * @Date: 2022-04-22 11:13:29
 * @lastEditors: luting
 * @LastEditTime: 2022-04-22 11:18:31
 */
import React from 'react';
import empty from 'root/assets/images/illustrator_empty.svg';
import style from './index.less';

interface ICommonEmpty {
  content: string;
}

const CommonEmpty: React.FC<ICommonEmpty> = (props) => {
  const { content } = props;
  return (
    <div className={style.diskEmpty}>
      <img src={empty} />
      <div>{content}</div>
    </div>
  );
};

export default CommonEmpty;
